import { Divider, Layout, Space, Typography } from "antd";

const { Text, Title } = Typography;
const { Content } = Layout;

export default function TermsAndConditions() {
  return (
    <div className="Privacy_Policy">
      <Layout style={{ minHeight: "100vh" }}>
        <Content style={{ padding: "24px" }}>
          <Space direction="vertical" size="large" style={{ width: "100%" }}>
            <Title level={1}>Terms of Service</Title>
            <Divider />
            <Text>
              Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the software
              (the "Service") operated by Webrex ("us", "we", or "our").
            </Text>
            <Title level={2}>Acceptance of Terms</Title>
            <Text>
              By accessing and using our Service, you agree to be bound by these Terms. If you disagree with any
              part of the terms, then you may not access the Service.
            </Text>
            <Title level={2}>Use of Service</Title>
            <Text>
              Your access to and use of the Service is conditioned on your acceptance of and compliance with these
              Terms. These Terms apply to all visitors, users and others who access or use the Service.
            </Text>
            <Title level={2}>Accounts</Title>
            <Text>
              When installing our software, you are required to provide us with information that is accurate,
              complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may
              result in immediate termination of your account on our Service.
            </Text>
            <Title level={2}>Termination</Title>
            <Text>
              We may terminate or suspend access to our Service immediately, without prior notice or liability, for
              any reason whatsoever, including without limitation if you breach the Terms.
            </Text>
            <Title level={2}>Governing Law</Title>
            <Text>
              These Terms shall be governed and construed in accordance with the laws of Gujarat, India, without
              regard to its conflict of law provisions.
            </Text>
            <Title level={2}>Changes</Title>
            <Text>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. In case
              of changes in it, it will be reflacted here, without any prior notice. What constitutes a material
              change will be determined at our sole discretion.
            </Text>
            <Title level={2}>Contact Us</Title>
            <Text>
              If you have any questions about these Terms, please contact us by e-mail at hello@webrexstudio.com or
              by mail using the details provided below:
            </Text>
            <Text>209, Saumya Square near Goverdhan party plot, Thaltej 380052, Ahmedabad, India.</Text>
          </Space>
        </Content>
      </Layout>
    </div>
  );
}